<template>
  <div class="select-input">
    <a-input
      v-if="inputType === 'input'"
      v-model:value="inputValue"
      v-bind="inputConfig"
      :placeholder="inputPlaceholder"
      :disabled="inputDisabled"
      @change="onValueChange"
    >
      <template #addonBefore>
        <a-select
          ref="selectRef"
          v-model:value="labelValue"
          v-bind="selectConfig"
          :options="labelOptions"
          :style="`width: ${labelWidth};font-size:13px;`"
          :getPopupContainer="(trigger: HTMLElement) => trigger.parentNode"
          @select="onLabelChange"
          @click="handleMouseClick"
        >
        </a-select>
      </template>
    </a-input>
    <a-input-number
      v-if="inputType === 'input-number'"
      v-model:value="inputValue"
      v-bind="inputConfig"
      :placeholder="inputPlaceholder"
      :disabled="inputDisabled"
      :formatter="onFormatter"
      :parser="onParser"
      @change="onValueChange"
      style="width: 100%"
    >
      <template #addonBefore>
        <a-select
          ref="selectRef"
          v-model:value="labelValue"
          v-bind="selectConfig"
          :options="labelOptions"
          :style="`width: ${labelWidth};font-size:13px;`"
          :getPopupContainer="(trigger: HTMLElement) => trigger.parentNode"
          @select="onLabelChange"
          @click="handleMouseClick"
        >
        </a-select>
      </template>
    </a-input-number>
  </div>
</template>

<script lang="ts" setup>
import { ref, watchEffect, PropType, onMounted } from "vue";
const props = defineProps({
  labelOptions: {
    type: Array,
    default: () => []
  },
  labelWidth: {
    type: String,
    default: "120px"
  },
  value: {
    type: Array as PropType<string[]>,
    default: () => []
  },
  selectConfig: {
    type: Object,
    default: () => ({})
  },
  inputConfig: {
    type: Object,
    default: () => ({})
  },
  inputType: {
    type: String,
    default: "input"
  }
});

const emit = defineEmits(["update:value"]);
const selectRef = ref();
const labelValue = ref();
const inputValue = ref("");
const inputPlaceholder = ref("");
const inputDisabled = ref(false);
const disabledList = Array.isArray(props.inputConfig.disabled)
  ? props.inputConfig.disabled
  : [];

const onLabelChange = (value: string, options: any) => {
  if (disabledList.includes(labelValue.value)) {
    inputValue.value = "";
  }
  if (options.placeholder) {
    inputPlaceholder.value = options.placeholder;
  }
  onValueChange();
};

const onValueChange = () => {
  emit("update:value", [labelValue.value, inputValue.value]);
};

const handleMouseClick = (e: any) => {
  const dom = selectRef.value.$el;
  const clearDom = dom.querySelector(".ant-select-clear");

  if (clearDom) {
    clearDom.addEventListener("click", (e: any) => {
      emit("update:value", [undefined, ""]);
    });
  }
};
const onParser = (value: string) => {
  if (props.inputConfig.parser === "percent") {
    const str = value.replace("%", "");
    const num = parseFloat(str);
    return num / 100;
  }
};
// onParser只会返回number类型，其他不属于number类型的数据，都会被传为""
const onFormatter = (value: number) => {
  if (props.inputConfig.formatter === "toPercent") {
    const num = (value * 100).toFixed(2).replace(/\.?0+$/, "");
    return `${num}%`;
  }
};

watchEffect(() => {
  if (props.value.length > 0) {
    labelValue.value = props.value[0] || undefined;
    inputValue.value = props.value[1] || "";
    inputDisabled.value =
      labelValue.value === undefined || disabledList.includes(labelValue.value);
  }
});

onMounted(() => {
  inputPlaceholder.value = props.inputConfig.placeholder || "";
});
</script>

<script lang="ts">
export default {
  name: "SelectInput"
};
</script>

<style lang="less" scoped>
:deep(.ant-select-item) {
  font-size: 13px;
}
</style>
